import styled from 'styled-components';
import {
  Flex,
  FlexSpace,
  TextField,
  formFieldRequiredLabel as requiredLabel,
} from '@elementary/common-ui/components';
import { capitalize } from '@elementary/common-ui/utils/common';
import { Typography } from '@mui/material';
import { UseFormRegister } from 'react-hook-form';
import { ScoreFormulaForm } from '../../types';

const ValueRow = styled(Flex)`
  justify-content: center;
  align-items: center;
  gap: 12px;
`;

const Dimension = styled(Typography)`
  font-size: 16px;
  font-weight: 500;
  line-height: normal;
`;

const InputNumber = styled(TextField)`
  width: 48px;
`;

const Text = styled(Typography)`
  line-height: normal;
  color: ${({ theme }) => theme.palette.common.gray2};
`;

type Props = {
  dimension: string;
  register: UseFormRegister<ScoreFormulaForm>;
};

const DimensionRow = ({ dimension, register }: Props) => (
  <FlexSpace height="48px">
    <Dimension>{capitalize(dimension)}</Dimension>

    <ValueRow>
      <Text>Dimension weight is</Text>

      <InputNumber
        {...register(`weights.${dimension}`, {
          required: requiredLabel,
          pattern: {
            value: /^\d+(\.\d+)?$/,
            message: 'Only numbers are allowed',
          },
        })}
      />

      <Text>%</Text>
    </ValueRow>
  </FlexSpace>
);

export default DimensionRow;
